import { styled } from 'styled-components';

import { breakpointTablet } from 'app/style/breakpoints';
import { colorNeutral, colorSecondary200 } from 'app/style/colors';
import { focus } from 'app/style/mixins';
import { spacing1, spacing3 } from 'app/style/spacing';

export const StyledButton = styled.button`
    background: ${colorNeutral};
    border: 1px solid ${colorSecondary200};
    box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
    padding: ${spacing3};
    border-radius: 8px;
    width: 100%;
    margin-bottom: ${spacing3};
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    ${focus}
    cursor: pointer;

    &:hover {
        background: ${colorSecondary200};
    }

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledInnerContainer = styled.div`
    padding-top: ${spacing3};
    display: flex;
    padding-left: ${spacing1};
    align-items: center;
`;

export const StyledImageContainer = styled.div`
    min-width: 40px;
    text-align: left;

    @media (min-width: ${breakpointTablet}) {
        min-width: 56px;
    }
`;
